
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11771',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11771",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.284",
  "data-fetching-client": "static-1.9542",
  "foundations-components": "static-1.7649",
  "foundations-components-legacy": "static-1.674",
  "foundations-theming": "static-1.4277",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7872",
  "hub-http-shared-msw-handlers": "static-1.9643",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11308",
  "I18n": "static-7.1593",
  "jasmine-runner": "static-1.6335",
  "marketplace-storefront-base": "static-1.11832",
  "quartz": "static-1.6816",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16515",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2728",
  "reporting-testing-lib": "static-1.8733",
  "settings-ui-lib": "static-1.12388",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6866",
  "ui-addon-i18n": "static-1.11011",
  "ui-addon-react-router-dom": "static-1.9410",
  "unified-auth": "static-1.301",
  "unified-auth-core-lib": "static-1.582",
  "usage-tracker": "static-1.7200",
  "usage-tracker-core": "static-1.7050",
  "customer-data-property-utils": "static-1.7946",
  "history": "static-4.47",
  "hub-http": "static-1.6083",
  "integrations-lib": "static-1.15630",
  "marketplace-ui-common": "static-1.19145",
  "property-management-iframe": "static-1.12647",
  "quartz-config": "static-1.594",
  "quartz-core": "static-1.6035",
  "quartz-routing": "static-1.246",
  "quick-fetch": "static-1.3799",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4507",
  "ts-schema": "static-1.3966",
  "ui-universal-auth": "static-1.8787",
  "UIComponents": "static-3.8255",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3290",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3093",
  "quartz-webpack": "static-1.3040",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3918",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4706",
  "foundations-theming-specialty": "static-1.1993",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9291",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5236",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1400",
  "ui-fonts": "static-1.570",
  "ui-images": "static-2.1118",
  "bend-plugin-foundations-theming": "static-1.2760",
  "foundations-theming-base": "static-1.3262",
  "stylex": "static-1.28",
  "HeadJS": "static-2.728",
  "hs-test-utils-bend-plugin": "static-1.2983",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4191",
  "ai-components-ui-library": "static-1.8553",
  "ai-rendering-library": "static-1.9529",
  "chirp-fetch": "static-1.1748",
  "connections-embed-lib": "static-1.729",
  "copilot-toolkit": "static-1.10711",
  "laboratory-lib": "static-3.7024",
  "marketplace-embed": "static-1.21647",
  "marketplace-ui-details": "static-1.9041",
  "marketplace-ui-reviews": "static-1.19101",
  "marketplace-ui-tracking": "static-1.13316",
  "sanitize-text": "static-1.8010",
  "ui-addon-video-player": "static-1.8561",
  "usage-tracker-multi": "static-1.5614",
  "usage-tracker-session-replay": "static-1.4886",
  "wootric-nps": "static-1.6847",
  "apollo-link-hub-http": "static-2.4516",
  "immer": "static-1.33",
  "immerable": "static-1.4019",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2409",
  "reporting-data": "static-1.66800",
  "cssUtils": "static-1.758",
  "flux-actions": "static-1.321",
  "HubStyle": "static-2.11616",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10076",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10239",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7190",
  "icons": "static-2.635",
  "marketplace-ui-apps-core": "static-1.17678",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4385",
  "foundations-components-test-utils": "static-1.5132",
  "quartz-i18n": "static-1.491",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3595",
  "customer-data-objects": "static-1.7518",
  "property-translator": "static-1.5274",
  "frontend-preferences-client": "static-1.7789",
  "hs-promise-utils": "static-1.5458",
  "hubspot-apollo-client": "static-1.4744",
  "integrations-error-boundary-lib": "static-1.13045",
  "integrations-tracking-lib": "static-1.5456",
  "native-integrations-shared-strings": "static-1.7652",
  "reselect": "static-2.16",
  "sanitize": "static-1.4339",
  "superstore": "static-1.4634",
  "ui-shepherd-react": "static-3.10011",
  "ai-settings-ui-library": "static-1.7652",
  "hub-http-janus": "static-1.813",
  "hubspotter-http": "static-1.4539",
  "immutable-less": "static-1.4519",
  "marketplace-ui-client-types": "static-1.16552",
  "nav-meta": "static-1.29134",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10107",
  "ui-addon-upgrades": "static-9.17757",
  "inbound-db-properties-service-client": "static-1.3732",
  "property-management-common": "static-1.4935",
  "ui-addon-iframeable": "static-1.8912",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.503",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.491",
  "quartz-head": "static-1.481",
  "quartz-test": "static-1.491",
  "quartz-tracking": "static-1.195",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3022",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20619",
  "ContentUtils": "static-1.67831",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2357",
  "customer-data-filters-ui": "static-1.39149",
  "customer-data-objects-ui-components": "static-1.12879",
  "customer-data-reference-ui-components": "static-1.13015",
  "embedded-academy-lib": "static-1.13787",
  "ExportDialog": "static-6.10254",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40835",
  "reporting-snowflake": "static-1.55418",
  "reporting-ui-components": "static-2.64071",
  "reporting-visualizations": "static-1.58876",
  "ui-addon-teams": "static-1.21336",
  "magpie-lib": "static-1.5459",
  "magpie-types": "static-1.4919",
  "simple-logging-lib": "static-1.2915",
  "navigation-components": "static-1.17497",
  "ai-studio-lib": "static-1.11182",
  "app-governance-lib": "static-1.1087",
  "developer-experience-shared-components": "static-1.10367",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7856",
  "ui-product-approvals": "static-1.27676",
  "ui-tool-access": "static-1.10010",
  "usage-based-billing-components-lib": "static-1.8197",
  "usage-tracker-anonymous": "static-1.5617",
  "usage-tracker-public": "static-1.7011",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3481",
  "persist-promise": "static-1.3573",
  "reference-resolvers": "static-1.8030",
  "ui-extensibility-client-types": "static-1.3806",
  "hubspot-apollo-cache": "static-1.203",
  "universal-page-editor-lib": "static-1.2866",
  "final-form": "static-1.66",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2365",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4935",
  "purchase-motions-components": "static-1.5588",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1416",
  "crm-component-utils": "static-1.38646",
  "crm-properties-common-lib": "static-1.5739",
  "customer-data-properties": "static-1.51001",
  "framework-data-schema-resolvers": "static-1.6738",
  "property-value-citations": "static-1.1615",
  "reference-resolvers-lite": "static-1.7951",
  "navigation-messaging": "static-1.6824",
  "hubspotter-http-shared-msw-handlers": "static-1.9641",
  "cms-field-types": "static-1.4674",
  "content-icons-ui": "static-1.2182",
  "conversations-skeleton-state": "static-1.7114",
  "crm-message-bus": "static-1.42567",
  "customer-data-filters-ui-msw-helpers": "static-1.21584",
  "customer-data-ui-utilities": "static-1.9689",
  "FormUrlGenerator": "static-2.4586",
  "framework-builder-read-service-client": "static-1.3894",
  "framework-data-schema-quick-fetch": "static-1.6643",
  "multi-account-reference-resolvers": "static-1.843",
  "onboarding-tours": "static-1.16353",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13250",
  "academy-common-lib": "static-1.13247",
  "content-assistance-lib": "static-1.7541",
  "dashboard-lib": "static-1.80905",
  "file-manager-components": "static-1.23123",
  "getting-started-shared-tasks": "static-1.18068",
  "hubspot-prosemirror": "static-1.17799",
  "hubspot-prosemirror-plugins": "static-1.17791",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19588",
  "share-with-third-party-component-lib": "static-1.8558",
  "ui-addon-draggable": "static-3.4633",
  "ui-asset-management-lib": "static-1.10804",
  "ui-business-units-lib": "static-1.8898",
  "user-context": "static-1.4965",
  "growth-payments-core": "static-1.24916",
  "reporting-plugins": "static-1.10063",
  "reporting-reports": "static-1.66478",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.590",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.29006",
  "react-codemirror": "static-1.10491",
  "framework-listing-lib": "static-2.28226",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30291",
  "apps-service-types": "static-1.3742",
  "oauth-service-types": "static-1.4112",
  "onboarding-scopes": "static-1.6328",
  "onboarding-tours-client": "static-1.4567",
  "platform-infra-nav-components": "static-1.7553",
  "subscription-experience-data-types": "static-1.14673",
  "crm-record-cards-service-types": "static-1.3503",
  "location-customization-utils-lib": "static-1.8771",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4364",
  "nav-client-types": "static-1.2222",
  "purchase-motions-api": "static-1.5591",
  "signup-constants": "static-1.18543",
  "signup-ui-url-generator": "static-2.7900",
  "trials-service-types": "static-1.3765",
  "card-properties-lib": "static-1.43715",
  "commerce-subscription-lib": "static-1.36651",
  "crm-actions": "static-1.6176",
  "crm-cards-sdk": "static-1.43118",
  "customer-data-properties-shared-msw-handlers": "static-1.8970",
  "customer-data-tracking": "static-1.6747",
  "hs-entities": "static-1.552",
  "pulse": "static-1.389",
  "calling-global-api": "static-1.63935",
  "calling-internal-common": "static-1.31165",
  "calling-lifecycle-internal": "static-1.65317",
  "calling-lifecycle-messages": "static-1.57611",
  "commerce-products-lib": "static-1.9031",
  "conditional-properties-service-client": "static-1.3684",
  "crm-links": "static-1.6134",
  "external-options-client-types": "static-1.4045",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4109",
  "meetings-icalendar-utils-lib": "static-1.497",
  "multi-currency-client-types": "static-1.3576",
  "object-builder-ui-client": "static-1.48227",
  "pipeline-validation-client-types": "static-1.3850",
  "smart-property-lib": "static-1.6199",
  "tiered-pricing": "static-1.934",
  "ui-addon-form-validation": "static-1.10858",
  "crm-pipelines-api-client-types": "static-1.4026",
  "react-dnd-compat": "static-1.4485",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5224",
  "growth-onboarding-confetti": "static-1.2937",
  "growth-onboarding-next-action-utils": "static-1.1474",
  "onboarding-tours-utils": "static-1.419",
  "ui-shepherd-tracker": "static-1.7392",
  "academy-service-client": "static-1.3545",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28122",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8249",
  "video-components-external": "static-1.10784",
  "video-data-lib": "static-1.34442",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8423",
  "payment-link-components": "static-1.23115",
  "ui-addon-emoji-picker": "static-1.9752",
  "EmailSignatureEditor": "static-1.24035",
  "viral-links-lib": "static-1.6905",
  "data-token-picker": "static-1.16160",
  "FileManagerLib": "static-1.38763",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5109",
  "getting-started-shared-tasks-store": "static-1.17186",
  "campaign-roi-lib": "static-1.8482",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7188",
  "customer-data-views-management": "static-1.25124",
  "framework-data-table": "static-2.11581",
  "marketing-platform-lib": "static-1.6710",
  "nudge-client-utils": "static-1.2286",
  "nudge-custom-ui-functions": "static-1.790",
  "app-users-service-client": "static-1.5409",
  "app-users-service-types": "static-1.4817",
  "mini-checkout-client": "static-1.26477",
  "onboarding-utils": "static-1.5217",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28107",
  "edison-service-client-types": "static-1.257",
  "eligibility-engine-service-types": "static-1.3046",
  "crm_data": "static-4.91471",
  "customer-data-sidebar": "static-2.45596",
  "enrichment-properties-lib": "static-1.15317",
  "commerce-billing-lib": "static-1.18675",
  "commerce-shared-components-lib": "static-1.18134",
  "commerce-tools-ui-lib": "static-1.9969",
  "crm-fe-perf": "static-1.22769",
  "directed-graph": "static-1.804",
  "event-emitter": "static-1.812",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31171",
  "shared-worker-versioning": "static-1.10904",
  "calling-usage-tracker": "static-1.6406",
  "voice-sms-access-library": "static-1.441",
  "commerce-permissions": "static-1.628",
  "products-iframe-lib": "static-1.7519",
  "products-ui-components-shared-msw-handlers": "static-1.10025",
  "breeze-intelligence-kit": "static-1.5415",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9726",
  "policy-lib": "static-1.6643",
  "react-tinymce": "static-1.54812",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9789",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53938",
  "tinymce-plugins": "static-1.57052",
  "tinymce-themes": "static-1.55908",
  "growth-onboarding-next-action-components": "static-1.1502",
  "user-context-client": "static-1.4478",
  "growth-onboarding-feedback-components": "static-1.6446",
  "content-media-composition-data-lib": "static-1.11726",
  "content-media-compositions": "static-2.15733",
  "media-bridge-lib": "static-1.18682",
  "commerce-tours-lib": "static-1.5825",
  "growth-onboarding-reliability": "static-1.4951",
  "sales-checkout-service-client": "static-1.3533",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21426",
  "sales-email-signature-service-client": "static-1.3708",
  "audio-components": "static-1.5705",
  "FileManagerCore": "static-1.38622",
  "FileManagerImages": "static-1.36274",
  "video-components": "static-1.12787",
  "crm-export-dialog": "static-1.6159",
  "crm-index-associations-lib": "static-1.6300",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1507",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2043",
  "nudge-renderer-utils": "static-1.2362",
  "whisper-core-api": "static-1.6173",
  "InboxConnectUtils": "static-4.14401",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5206",
  "settings-content-modals": "static-1.45652",
  "crm_universal": "static-1.21762",
  "customer-data-email": "static-1.17787",
  "card-payment-highlight-lib": "static-1.36703",
  "card-subscription-highlight-lib": "static-1.39074",
  "commerce-contract-lib": "static-1.11449",
  "customer-data-content": "static-1.27002",
  "invoices-highlight-card-lib": "static-1.54237",
  "orders-highlight-card-lib": "static-1.21044",
  "products-highlight-card-lib": "static-1.17315",
  "project-storage": "static-1.4598",
  "quotes-highlight-card-lib": "static-1.71414",
  "crm-source-interpretation-lib": "static-1.5197",
  "utility-belt": "static-1.2405",
  "payments-enrollment-embed-lib": "static-1.22198",
  "customer-data-rte": "static-1.32612",
  "cv-backend-services": "static-1.1527",
  "growth-onboarding-empty-states": "static-1.5462",
  "payments-post-enroll-local-storage-lib": "static-1.4979",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37504",
  "calling-orchestration-schema": "static-1.35218",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2908",
  "interframe": "static-3.4628",
  "tinymce-data": "static-1.40023",
  "ui-addon-sales-email": "static-1.5078",
  "layout-dnd-components": "static-1.12172",
  "layout-dnd-utils": "static-1.11147",
  "ui-brand-identity-lib": "static-1.14368",
  "NamespacedHubStyle": "static-2.8956",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4396",
  "video-embed": "static-1.35276",
  "social-insights-client-types": "static-1.21589",
  "deal-intel-utils": "static-1.1511",
  "checkout-sdk": "static-3.23320",
  "checkout-service-types": "static-1.3715",
  "company-details-components": "static-1.6051",
  "payment-method-components": "static-1.6758",
  "pricing-pages-ui-components": "static-1.12978",
  "quote-checkout-service-types": "static-1.3351",
  "upgrade-catalog-service-types": "static-1.3391",
  "access-control-lib": "static-1.10303",
  "EmailComponents": "static-1.54329",
  "EmailData": "static-1.53006",
  "redux-less": "static-2.9351",
  "sequences-lib": "static-1.7800",
  "ui-gdpr-components": "static-1.10213",
  "products-ui-components": "static-1.39550",
  "quotes-ui-lib": "static-1.80135",
  "SalesContentIndexUI": "static-3.9006",
  "accounting-integrations-ui-components": "static-1.6838",
  "invoices-ui-lib": "static-1.54253",
  "commerce-products-api": "static-1.2059",
  "SafeStorage": "static-1.4267",
  "invoices-iframe-lib": "static-1.56311",
  "quotes-modal-lib": "static-1.102092",
  "stripe-embedded-components": "static-1.7257",
  "draft-content-plugins": "static-1.27879",
  "ContentData": "static-1.67906",
  "layout-data-lib": "static-1.9472",
  "outpost": "static-1.4064",
  "hub-http-rxjs": "static-1.779",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3794",
  "billing-payments-client-types": "static-1.3854",
  "account-and-billing-fintech-outages": "static-3.18327",
  "pricing-pages-api": "static-1.12843",
  "ContentComponents": "static-2.70787",
  "marketing-contacts-lib": "static-1.9353",
  "marketing-email-service-types": "static-1.1814",
  "messaging-editing-lib": "static-1.45810",
  "messaging-usage-based-billing-components-lib": "static-1.672",
  "automation-ui-source-apps": "static-1.18418",
  "automation-ui-types": "static-1.19336",
  "messaging-types-lib": "static-1.45547",
  "onboarding-settings-client": "static-1.4370",
  "sequences-client-types-lib": "static-1.7657",
  "commerce-tax-lib": "static-1.384",
  "property-description-translator": "static-1.3720",
  "FireAlarmUi": "static-1.4394",
  "sales-templates-service-types-lib": "static-1.4053",
  "commerce-analytics-service-client": "static-1.3521",
  "totals-ui-components": "static-1.23168",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14911",
  "advanced-menus-lib": "static-1.11879",
  "ui-memberships-settings-lib": "static-1.33629",
  "demographics-service-types": "static-1.1514",
  "automation-ui-ubb": "static-1.5252",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7206",
  "data-token-views": "static-1.16141",
  "forms-utils-lib": "static-1.12301",
  "payments-embed-points-lib": "static-1.12737",
  "simple-menus-core": "static-1.14910",
  "simple-menus-lib": "static-1.16427",
  "ui-addon-draggable-compat": "static-2.4119",
  "videoconference-integration-components": "static-1.6621",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76718",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13517",
  "web-interactives-data": "static-1.13518",
  "messaging-shared-utils-lib": "static-1.121",
  "messaging-user-info-utils-lib": "static-1.291",
  "email-portal-health-service-types": "static-1.841",
  "commerce-totals-service-types": "static-1.3702",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21272",
  "automation-ui-usage-tracking": "static-1.20735",
  "data-studio-ubb": "static-1.2294",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26602",
  "collaboration-sidebar": "static-1.57314",
  "content-management-data-lib": "static-1.5202",
  "copilot-plugins": "static-1.10684",
  "cta-picker": "static-1.36012",
  "customer-agent-discovery-components-lib": "static-1.2628",
  "editor-components": "static-1.13028",
  "editor-iframe-lib": "static-1.8209",
  "error-messaging-js": "static-1.5055",
  "FormsCommonComponents": "static-1.85455",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.61",
  "redux-request-state": "static-1.10511",
  "SharedLegalStrings": "static-1.1617",
  "smart-content-core": "static-1.42034",
  "smart-content-lib": "static-1.42687",
  "social-composer-lib": "static-1.58410",
  "structured-content-lib": "static-1.24793",
  "theme-previewer-lib": "static-1.52863",
  "tinymce-copilot": "static-1.16006",
  "xray-recommendation-lib": "static-1.7685",
  "automation-ui-routing": "static-1.20693",
  "sql-reporting-client-types": "static-1.5530",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41821",
  "campaigns-utils-lib": "static-1.3020",
  "reporting-enablement": "static-1.22326",
  "chatspot-widget-iframe": "static-1.20611",
  "collaboration-sidebar-common": "static-1.2111",
  "forms-ai-lib": "static-1.4101",
  "codemirror-dlb": "static-1.58277",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6293",
  "report-customization-components": "static-1.12710",
  "data-quality-ui-library": "static-1.12491",
  "html-to-image": "static-1.50",
  "reporting-insights-lib": "static-1.1266"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11771",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.284",
  "data-fetching-client": "/data-fetching-client/static-1.9542",
  "foundations-components": "/foundations-components/static-1.7649",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.674",
  "foundations-theming": "/foundations-theming/static-1.4277",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9643",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11308",
  "I18n": "/I18n/static-7.1593",
  "jasmine-runner": "/jasmine-runner/static-1.6335",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11832",
  "quartz": "/quartz/static-1.6816",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16515",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2728",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8733",
  "settings-ui-lib": "/settings-ui-lib/static-1.12388",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6866",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11011",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9410",
  "unified-auth": "/unified-auth/static-1.301",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.582",
  "usage-tracker": "/usage-tracker/static-1.7200",
  "usage-tracker-core": "/usage-tracker-core/static-1.7050",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7946",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6083",
  "integrations-lib": "/integrations-lib/static-1.15630",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19145",
  "property-management-iframe": "/property-management-iframe/static-1.12647",
  "quartz-config": "/quartz-config/static-1.594",
  "quartz-core": "/quartz-core/static-1.6035",
  "quartz-routing": "/quartz-routing/static-1.246",
  "quick-fetch": "/quick-fetch/static-1.3799",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4507",
  "ts-schema": "/ts-schema/static-1.3966",
  "ui-universal-auth": "/ui-universal-auth/static-1.8787",
  "UIComponents": "/UIComponents/static-3.8255",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3290",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3093",
  "quartz-webpack": "/quartz-webpack/static-1.3040",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3918",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4706",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1993",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9291",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5236",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1400",
  "ui-fonts": "/ui-fonts/static-1.570",
  "ui-images": "/ui-images/static-2.1118",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2760",
  "foundations-theming-base": "/foundations-theming-base/static-1.3262",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.728",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2983",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4191",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8553",
  "ai-rendering-library": "/ai-rendering-library/static-1.9529",
  "chirp-fetch": "/chirp-fetch/static-1.1748",
  "connections-embed-lib": "/connections-embed-lib/static-1.729",
  "copilot-toolkit": "/copilot-toolkit/static-1.10711",
  "laboratory-lib": "/laboratory-lib/static-3.7024",
  "marketplace-embed": "/marketplace-embed/static-1.21647",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9041",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19101",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13316",
  "sanitize-text": "/sanitize-text/static-1.8010",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8561",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5614",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4886",
  "wootric-nps": "/wootric-nps/static-1.6847",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4516",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4019",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2409",
  "reporting-data": "/reporting-data/static-1.66800",
  "cssUtils": "/cssUtils/static-1.758",
  "flux-actions": "/flux-actions/static-1.321",
  "HubStyle": "/HubStyle/static-2.11616",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10076",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10239",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7190",
  "icons": "/icons/static-2.635",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17678",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4385",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5132",
  "quartz-i18n": "/quartz-i18n/static-1.491",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3595",
  "customer-data-objects": "/customer-data-objects/static-1.7518",
  "property-translator": "/property-translator/static-1.5274",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7789",
  "hs-promise-utils": "/hs-promise-utils/static-1.5458",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4744",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13045",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5456",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7652",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4339",
  "superstore": "/superstore/static-1.4634",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10011",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7652",
  "hub-http-janus": "/hub-http-janus/static-1.813",
  "hubspotter-http": "/hubspotter-http/static-1.4539",
  "immutable-less": "/immutable-less/static-1.4519",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16552",
  "nav-meta": "/nav-meta/static-1.29134",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10107",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17757",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3732",
  "property-management-common": "/property-management-common/static-1.4935",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8912",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.503",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.491",
  "quartz-head": "/quartz-head/static-1.481",
  "quartz-test": "/quartz-test/static-1.491",
  "quartz-tracking": "/quartz-tracking/static-1.195",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3022",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20619",
  "ContentUtils": "/ContentUtils/static-1.67831",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2357",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39149",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12879",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13015",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13787",
  "ExportDialog": "/ExportDialog/static-6.10254",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40835",
  "reporting-snowflake": "/reporting-snowflake/static-1.55418",
  "reporting-ui-components": "/reporting-ui-components/static-2.64071",
  "reporting-visualizations": "/reporting-visualizations/static-1.58876",
  "ui-addon-teams": "/ui-addon-teams/static-1.21336",
  "magpie-lib": "/magpie-lib/static-1.5459",
  "magpie-types": "/magpie-types/static-1.4919",
  "simple-logging-lib": "/simple-logging-lib/static-1.2915",
  "navigation-components": "/navigation-components/static-1.17497",
  "ai-studio-lib": "/ai-studio-lib/static-1.11182",
  "app-governance-lib": "/app-governance-lib/static-1.1087",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10367",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7856",
  "ui-product-approvals": "/ui-product-approvals/static-1.27676",
  "ui-tool-access": "/ui-tool-access/static-1.10010",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8197",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5617",
  "usage-tracker-public": "/usage-tracker-public/static-1.7011",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3481",
  "persist-promise": "/persist-promise/static-1.3573",
  "reference-resolvers": "/reference-resolvers/static-1.8030",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3806",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.203",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2866",
  "final-form": "/final-form/static-1.66",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2365",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4935",
  "purchase-motions-components": "/purchase-motions-components/static-1.5588",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1416",
  "crm-component-utils": "/crm-component-utils/static-1.38646",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5739",
  "customer-data-properties": "/customer-data-properties/static-1.51001",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6738",
  "property-value-citations": "/property-value-citations/static-1.1615",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7951",
  "navigation-messaging": "/navigation-messaging/static-1.6824",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9641",
  "cms-field-types": "/cms-field-types/static-1.4674",
  "content-icons-ui": "/content-icons-ui/static-1.2182",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7114",
  "crm-message-bus": "/crm-message-bus/static-1.42567",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21584",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9689",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4586",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3894",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6643",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.843",
  "onboarding-tours": "/onboarding-tours/static-1.16353",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13250",
  "academy-common-lib": "/academy-common-lib/static-1.13247",
  "content-assistance-lib": "/content-assistance-lib/static-1.7541",
  "dashboard-lib": "/dashboard-lib/static-1.80905",
  "file-manager-components": "/file-manager-components/static-1.23123",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18068",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17799",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17791",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19588",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8558",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4633",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10804",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8898",
  "user-context": "/user-context/static-1.4965",
  "growth-payments-core": "/growth-payments-core/static-1.24916",
  "reporting-plugins": "/reporting-plugins/static-1.10063",
  "reporting-reports": "/reporting-reports/static-1.66478",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.590",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.29006",
  "react-codemirror": "/react-codemirror/static-1.10491",
  "framework-listing-lib": "/framework-listing-lib/static-2.28226",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30291",
  "apps-service-types": "/apps-service-types/static-1.3742",
  "oauth-service-types": "/oauth-service-types/static-1.4112",
  "onboarding-scopes": "/onboarding-scopes/static-1.6328",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4567",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7553",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14673",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3503",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8771",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4364",
  "nav-client-types": "/nav-client-types/static-1.2222",
  "purchase-motions-api": "/purchase-motions-api/static-1.5591",
  "signup-constants": "/signup-constants/static-1.18543",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7900",
  "trials-service-types": "/trials-service-types/static-1.3765",
  "card-properties-lib": "/card-properties-lib/static-1.43715",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36651",
  "crm-actions": "/crm-actions/static-1.6176",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43118",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8970",
  "customer-data-tracking": "/customer-data-tracking/static-1.6747",
  "hs-entities": "/hs-entities/static-1.552",
  "pulse": "/pulse/static-1.389",
  "calling-global-api": "/calling-global-api/static-1.63935",
  "calling-internal-common": "/calling-internal-common/static-1.31165",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65317",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57611",
  "commerce-products-lib": "/commerce-products-lib/static-1.9031",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3684",
  "crm-links": "/crm-links/static-1.6134",
  "external-options-client-types": "/external-options-client-types/static-1.4045",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4109",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.497",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3576",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48227",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3850",
  "smart-property-lib": "/smart-property-lib/static-1.6199",
  "tiered-pricing": "/tiered-pricing/static-1.934",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10858",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4026",
  "react-dnd-compat": "/react-dnd-compat/static-1.4485",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5224",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2937",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1474",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.419",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7392",
  "academy-service-client": "/academy-service-client/static-1.3545",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28122",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8249",
  "video-components-external": "/video-components-external/static-1.10784",
  "video-data-lib": "/video-data-lib/static-1.34442",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8423",
  "payment-link-components": "/payment-link-components/static-1.23115",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9752",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24035",
  "viral-links-lib": "/viral-links-lib/static-1.6905",
  "data-token-picker": "/data-token-picker/static-1.16160",
  "FileManagerLib": "/FileManagerLib/static-1.38763",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5109",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17186",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8482",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7188",
  "customer-data-views-management": "/customer-data-views-management/static-1.25124",
  "framework-data-table": "/framework-data-table/static-2.11581",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6710",
  "nudge-client-utils": "/nudge-client-utils/static-1.2286",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.790",
  "app-users-service-client": "/app-users-service-client/static-1.5409",
  "app-users-service-types": "/app-users-service-types/static-1.4817",
  "mini-checkout-client": "/mini-checkout-client/static-1.26477",
  "onboarding-utils": "/onboarding-utils/static-1.5217",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28107",
  "edison-service-client-types": "/edison-service-client-types/static-1.257",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3046",
  "crm_data": "/crm_data/static-4.91471",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45596",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15317",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18675",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18134",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9969",
  "crm-fe-perf": "/crm-fe-perf/static-1.22769",
  "directed-graph": "/directed-graph/static-1.804",
  "event-emitter": "/event-emitter/static-1.812",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31171",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10904",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6406",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.441",
  "commerce-permissions": "/commerce-permissions/static-1.628",
  "products-iframe-lib": "/products-iframe-lib/static-1.7519",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10025",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5415",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9726",
  "policy-lib": "/policy-lib/static-1.6643",
  "react-tinymce": "/react-tinymce/static-1.54812",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9789",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53938",
  "tinymce-plugins": "/tinymce-plugins/static-1.57052",
  "tinymce-themes": "/tinymce-themes/static-1.55908",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1502",
  "user-context-client": "/user-context-client/static-1.4478",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6446",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11726",
  "content-media-compositions": "/content-media-compositions/static-2.15733",
  "media-bridge-lib": "/media-bridge-lib/static-1.18682",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5825",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4951",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3533",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21426",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3708",
  "audio-components": "/audio-components/static-1.5705",
  "FileManagerCore": "/FileManagerCore/static-1.38622",
  "FileManagerImages": "/FileManagerImages/static-1.36274",
  "video-components": "/video-components/static-1.12787",
  "crm-export-dialog": "/crm-export-dialog/static-1.6159",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6300",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1507",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2043",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2362",
  "whisper-core-api": "/whisper-core-api/static-1.6173",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14401",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5206",
  "settings-content-modals": "/settings-content-modals/static-1.45652",
  "crm_universal": "/crm_universal/static-1.21762",
  "customer-data-email": "/customer-data-email/static-1.17787",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36703",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39074",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11449",
  "customer-data-content": "/customer-data-content/static-1.27002",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54237",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21044",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17315",
  "project-storage": "/project-storage/static-1.4598",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71414",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5197",
  "utility-belt": "/utility-belt/static-1.2405",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22198",
  "customer-data-rte": "/customer-data-rte/static-1.32612",
  "cv-backend-services": "/cv-backend-services/static-1.1527",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5462",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4979",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37504",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35218",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2908",
  "interframe": "/interframe/static-3.4628",
  "tinymce-data": "/tinymce-data/static-1.40023",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5078",
  "layout-dnd-components": "/layout-dnd-components/static-1.12172",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11147",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14368",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8956",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4396",
  "video-embed": "/video-embed/static-1.35276",
  "social-insights-client-types": "/social-insights-client-types/static-1.21589",
  "deal-intel-utils": "/deal-intel-utils/static-1.1511",
  "checkout-sdk": "/checkout-sdk/static-3.23320",
  "checkout-service-types": "/checkout-service-types/static-1.3715",
  "company-details-components": "/company-details-components/static-1.6051",
  "payment-method-components": "/payment-method-components/static-1.6758",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.12978",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3351",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3391",
  "access-control-lib": "/access-control-lib/static-1.10303",
  "EmailComponents": "/EmailComponents/static-1.54329",
  "EmailData": "/EmailData/static-1.53006",
  "redux-less": "/redux-less/static-2.9351",
  "sequences-lib": "/sequences-lib/static-1.7800",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10213",
  "products-ui-components": "/products-ui-components/static-1.39550",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80135",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9006",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6838",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54253",
  "commerce-products-api": "/commerce-products-api/static-1.2059",
  "SafeStorage": "/SafeStorage/static-1.4267",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56311",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102092",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7257",
  "draft-content-plugins": "/draft-content-plugins/static-1.27879",
  "ContentData": "/ContentData/static-1.67906",
  "layout-data-lib": "/layout-data-lib/static-1.9472",
  "outpost": "/outpost/static-1.4064",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.779",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3794",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3854",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18327",
  "pricing-pages-api": "/pricing-pages-api/static-1.12843",
  "ContentComponents": "/ContentComponents/static-2.70787",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9353",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1814",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45810",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.672",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18418",
  "automation-ui-types": "/automation-ui-types/static-1.19336",
  "messaging-types-lib": "/messaging-types-lib/static-1.45547",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4370",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7657",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.384",
  "property-description-translator": "/property-description-translator/static-1.3720",
  "FireAlarmUi": "/FireAlarmUi/static-1.4394",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4053",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3521",
  "totals-ui-components": "/totals-ui-components/static-1.23168",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14911",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11879",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33629",
  "demographics-service-types": "/demographics-service-types/static-1.1514",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5252",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7206",
  "data-token-views": "/data-token-views/static-1.16141",
  "forms-utils-lib": "/forms-utils-lib/static-1.12301",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12737",
  "simple-menus-core": "/simple-menus-core/static-1.14910",
  "simple-menus-lib": "/simple-menus-lib/static-1.16427",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4119",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6621",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76718",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13517",
  "web-interactives-data": "/web-interactives-data/static-1.13518",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.121",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.291",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.841",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3702",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21272",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20735",
  "data-studio-ubb": "/data-studio-ubb/static-1.2294",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26602",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57314",
  "content-management-data-lib": "/content-management-data-lib/static-1.5202",
  "copilot-plugins": "/copilot-plugins/static-1.10684",
  "cta-picker": "/cta-picker/static-1.36012",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2628",
  "editor-components": "/editor-components/static-1.13028",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8209",
  "error-messaging-js": "/error-messaging-js/static-1.5055",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85455",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.61",
  "redux-request-state": "/redux-request-state/static-1.10511",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1617",
  "smart-content-core": "/smart-content-core/static-1.42034",
  "smart-content-lib": "/smart-content-lib/static-1.42687",
  "social-composer-lib": "/social-composer-lib/static-1.58410",
  "structured-content-lib": "/structured-content-lib/static-1.24793",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52863",
  "tinymce-copilot": "/tinymce-copilot/static-1.16006",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7685",
  "automation-ui-routing": "/automation-ui-routing/static-1.20693",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5530",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41821",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3020",
  "reporting-enablement": "/reporting-enablement/static-1.22326",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20611",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2111",
  "forms-ai-lib": "/forms-ai-lib/static-1.4101",
  "codemirror-dlb": "/codemirror-dlb/static-1.58277",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6293",
  "report-customization-components": "/report-customization-components/static-1.12710",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12491",
  "html-to-image": "/html-to-image/static-1.50",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1266"
}
};
